import { getTokenField } from '../token';

export const hasAccountActiveSubscription = () => {
  const activeSubscriptionTypes = ['stripe_based_started'];
  const subscriptionType = getTokenField('subscription_type') || '';
  return activeSubscriptionTypes.includes(subscriptionType);
};
